import React, { useState } from "react";
import { leadershipTracks } from "../mock/mock";
import { CheckCircle2, Target } from "lucide-react";

const LeadershipTracks = () => {
  const [active, setActive] = useState(leadershipTracks[0].id);
  const track = leadershipTracks.find((t) => t.id === active) || leadershipTracks[0];

  return (
    <section id="tracks" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-bronze" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-ink/60">
                Leadership Tracks
              </span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-ink leading-[1.05] font-light">
              Five leadership tracks. One senior operator.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-ink/65 leading-relaxed">
              Different mandates share the same operating discipline. Select a track to see how my
              experience maps to it — the target titles, the value I bring, and the proof behind it.
            </p>
          </div>
        </div>

        {/* Tab pills */}
        <div className="flex flex-wrap gap-2 mb-10">
          {leadershipTracks.map((t) => (
            <button
              key={t.id}
              onClick={() => setActive(t.id)}
              className={`px-5 py-3 text-xs uppercase tracking-[0.2em] rounded-sm border transition-all ${
                active === t.id
                  ? "bg-ink text-ivory-50 border-ink shadow-sm"
                  : "bg-transparent text-ink/70 border-ink/15 hover:border-ink hover:text-ink"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Detail card */}
        <div className="bg-ivory-100/70 border border-ink/10 rounded-sm p-8 lg:p-12">
          <div className="grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
              <div className="text-[11px] uppercase tracking-[0.28em] text-bronze font-medium mb-4">
                Track · {leadershipTracks.findIndex((x) => x.id === track.id) + 1} of {leadershipTracks.length}
              </div>
              <h3 className="font-serif-display text-3xl lg:text-4xl text-ink leading-[1.1] font-light mb-6">
                {track.title}
              </h3>

              <div className="text-[11px] uppercase tracking-[0.22em] text-ink/55 mb-3">
                Target titles
              </div>
              <ul className="flex flex-wrap gap-2">
                {track.targetTitles.map((t) => (
                  <li
                    key={t}
                    className="inline-flex items-center px-3 py-1.5 bg-ivory-50 border border-ink/10 text-xs text-ink/80 rounded-sm"
                  >
                    {t}
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-7 space-y-8">
              <div>
                <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-ink/55 mb-3">
                  <Target className="h-3.5 w-3.5 text-bronze" />
                  What I bring
                </div>
                <p className="text-[16px] lg:text-[17px] text-ink/85 leading-[1.75]">
                  {track.pitch}
                </p>
              </div>

              <div className="border-t border-ink/10 pt-6">
                <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-ink/55 mb-3">
                  <CheckCircle2 className="h-3.5 w-3.5 text-bronze" />
                  Proof
                </div>
                <p className="text-[15px] text-ink/75 leading-[1.7]">{track.proof}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipTracks;
